export const tabEnums = [
    "Doanh thu từ các dịch vụ",
    "Doanh thu bình quân/ bill",
    "Số lượt dịch vụ"
]